import * as React from 'react';
import { connect } from 'react-redux';
import { ApplicationState } from '../../../store';
import { IFieldMapping, ExternalFieldInfo, MappingType } from '../../../store/integration/common';
import { actionCreators, spoFieldToPpmxFieldsMap, SpoFieldType } from '../../../store/integration/SpoStore';
import { SourceType } from '../../../store/ExternalEpmConnectStore';
import MappingPanel from "../MappingPanel";
import { EntityType } from '../../../entities/common';
import { nameof } from '../../../store/services/metadataService';
import { ProjectAttrs } from '../../../store/ProjectsListStore';
import ProjectStageMappingControl from '../ProjectStageMappingControl';
import { Field } from '../../../entities/Metadata';

type OwnProps = {
    onDismiss: () => void;
    connectionId: string;
}
type StateProps = {
    error: string | null,
    mapping: IFieldMapping[] | null,
    stageMapping?: IFieldMapping,
    spoProjectFields: ExternalFieldInfo[],
    isLoading: boolean,
    ppmxProjectStageField: Field;
}
type Props = OwnProps & StateProps & typeof actionCreators;

const SpoMappingPanel = (props: Props) => {
    const [stageMapping, setStageMapping] = React.useState(props.stageMapping);
    const [stageMappingIsDirty, setStageMappingIsDirty] = React.useState(false);

    React.useEffect(() => {
        props.loadMapping(props.connectionId);
        props.loadSpoProjectFields(props.connectionId);
    }, [props.connectionId]);
    React.useEffect(() => setStageMapping(props.stageMapping), [props.stageMapping]);

    return <MappingPanel
        className='spo-mapping-panel'
        isLoading={props.isLoading}
        error={props.error}
        onDismiss={props.onDismiss}
        connector={SourceType.Spo}
        entityType={EntityType.Project}
        externalFields={props.spoProjectFields}
        typesMap={spoFieldToPpmxFieldsMap}
        mapping={props.mapping}
        showTransformationScript={true}
        updateMapping={mapping => {
            props.updateMapping(props.connectionId, {mapping, stageMapping});
            props.onDismiss();
        }}
        mappingTypes={[MappingType.ToPpmx, MappingType.FromPpmx]}
        isDirty={stageMappingIsDirty}
    >
        {!props.isLoading && <ProjectStageMappingControl
            sourceType={SourceType.Spo}
            ppmxField={props.ppmxProjectStageField}
            stageMapping={stageMapping}
            externalFields={props.spoProjectFields}
            externalFieldTypes={[SpoFieldType.String]}
            onMappingUpdated={(value) => {
                setStageMapping(value);
                setStageMappingIsDirty(true);
            }}
        />}

    </MappingPanel>;
}

function mapStateToProps(state: ApplicationState, ownProps?: OwnProps): StateProps {
    const projectFields = state.fields[EntityType.Project];
    return {
        error: state.spo.connections.error,
        mapping: state.spo.connections.mapping.entities,
        stageMapping: state.spo.connections.mapping.stageMapping,
        spoProjectFields: state.spo.connections.spoProjectFields.entities,
        isLoading: state.spo.connections.spoProjectFields.isLoading || state.spo.connections.mapping.isLoading,
        ppmxProjectStageField: projectFields.allIds.map(_ => projectFields.byId[_]).find(_ => _.name === nameof<ProjectAttrs>("Stage"))!,
    }
}

export default connect(mapStateToProps, actionCreators)(SpoMappingPanel);